import YouTube, { YouTubeProps } from 'react-youtube';
import { useState } from 'react';
import classNames from 'classnames';
import Button from '../Button';

import PlaySVG from '@/svg/play.svg?url';

interface Props {
    id: string;
}

type YoutubePlayerInstance = {
    playVideo: () => void;
};

const YoutubeVideo = ({ id }: Props) => {
    const [instance, setInstance] = useState<YoutubePlayerInstance>();
    const [isPlaying, setIsPlaying] = useState(false);
    const onPlayerReady: YouTubeProps['onReady'] = (event) => {
        setInstance(event.target);
    };

    return (
        <div
            className={classNames('youtube-video', {
                'youtube-video--playing': isPlaying,
            })}
        >
            <button
                className="youtube-video__preview"
                onClick={() => {
                    if (instance) {
                        instance.playVideo();
                    }
                }}
            >
                {instance && (
                    <Button
                        geometryVariant="mustache"
                        icon={
                            // eslint-disable-next-line @next/next/no-img-element
                            <img src={PlaySVG} alt="" width={24} height={24} className="img-fluid" decoding="async" />
                        }
                        tag="span"
                        className="youtube-video__button"
                    />
                )}
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={`https://img.youtube.com/vi/${id}/0.jpg`} alt="" decoding="async" loading="lazy" />
            </button>
            <YouTube
                videoId={id} // defaults -> ''
                id={id} // defaults -> ''
                onReady={onPlayerReady}
                className="youtube-video__player"
                onPlay={() => {
                    setIsPlaying(true);
                }}
                onPause={() => {
                    setIsPlaying(false);
                }}
                onEnd={() => {
                    setIsPlaying(false);
                }}
            />
        </div>
    );
};

export default YoutubeVideo;
